<template>
  <div v-if="payload.question">
    <boolean-question v-if="isBooleanQuestion"
                      :question="payload.question" :resource_data="payload.resource_data" :resource_type="payload.resource_type" :resource_id="payload.resource_id">
    </boolean-question>
    <div v-else class="is-flex is-align-items-center" :class="[textClass]">
      <p><b>{{payload.question.designator}}: </b></p>
      <div class="horizontal_space"></div>
      <p @click="edit()" class="blue_text btn">{{content}}</p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import QuestionsHelper from '@/custom/classes/questions_helper.js'
import BooleanQuestion from '@/components/BooleanQuestion'
export default {
  name: 'question-editor',
  props: {
    payload: {
      type: Object
    },
    textClass: {
      type: String
    }
  },
  data () {
    return {
      questions_helper: new QuestionsHelper()
    }
  },
  computed: {
    content () {
      let answer_text = this.questions_helper.getAllAnswersText(this.payload.question)
      return answer_text.length > 0 ? answer_text : 'CREATE'
    },
    isBooleanQuestion () {
      let options = this.payload.question.options
      return options.length == 2 && ((options[0].text == 'TRUE' || options[1].text == 'TRUE') && (options[0].text == 'FALSE' || options[1].text == 'FALSE'))
    }
  },
  methods: {
    edit () {
      this.create({
        designator: 'questions-form',
        component_name: 'QuestionsForm',
        data: this.payload.question,
        modal_title: this.payload.question.info.applicant_text,
        resource_type: this.payload.resource_type,
        resource_id: this.payload.resource_id,
        company_id: this.payload.resource_data ? this.payload.resource_data.company.id : undefined,
        props: {
          singleChoose: ['urgency'].includes(this.payload.question.designator)
        }
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    BooleanQuestion
  }
}
</script>
